<template>
  <div id='un_head' class='z_4'>
    <div id='un_head_wrap' @click='goHome'>
      <GoldLogo class='un-logo cur_p' />
    </div>
  </div>
</template>
<script>
import GoldLogo from '$svgs/GoldLogo.vue'
export default {
  methods: {
    goHome () {
      this.$router.push('/')
    }
  },
  components: {
    GoldLogo
  }
}
</script>
<style lang='scss' scoped>
#un_head{
  position: absolute;
  width:20rem;
  height:8rem;
  background-color: $c_item-nav;
  padding: 2.4rem;
  .un-logo{
    display: inline-block;
    width:15rem;
    height:5rem;
    vertical-align: middle;
    margin-right:0rem;
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/shared/Head.vue